import { apiRequest } from '../../api-client';

export interface EditUserParams {
  token: string;
  enterpriseId: string;
  userId: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  enabled?: boolean;
  isEnterpriseAdmin?: boolean;
  // Per-subscription Monitor mcp-write toggles applied via the backend edit-user route.
  monitorEntitlements?: Array<{ subscriptionId: string; mcpWrite: boolean }>;
}

export interface EditUserResult {
  updated?: string[];
  errors?: string[];
}

/**
 * Edit a user within an enterprise.
 * PUT /api-internal/enterprise/:enterprise_id/users/:user_id
 */
export function editEnterpriseUser({
  token,
  enterpriseId,
  userId,
  ...fields
}: EditUserParams): Promise<EditUserResult> {
  return apiRequest<EditUserResult>({
    method: 'PUT',
    endpoint: `/api-internal/enterprise/${enterpriseId}/users/${userId}`,
    token,
    body: fields
  });
}
